import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import {createImgObj, getSelfie} from '../CompanyEmployees/CompanyEmployeesApi';
import axios from "axios";
import {URL} from "../../Apis/Constants";
import {errorMsg} from "../../Apis/functions";
import {ASSETS_SERVICE, STATUS_SERVICE, USER_SERVICE} from "../EndPoints";
import { UploadImage } from '../ShareSlice/shareApi';
import { TABLES } from '../../Apis/Tables';

export const SERVICE_ADVANCED_SEARCH = 'advanced-search-service/simple';
export const SERVICE_ADVANCED_SEARCH_SIMPLE_SEARCH_USER= 'advanced-search-service/simple/user';
export const PUBLIC_SEARCH_USERS_BY_USER_TYPE = 'user-service/public/search';

//Delete Items /assets-service/delete-by-ids/by-table/${table} assets-module assets-controller
//@Deprecated
export const DeleteItemsApi = createAsyncThunk(
    'commons/deleteItemsApi',
    async ({ tableName, body, showToast = true }) => {
        let result = await apiInstance
            .post(`${ASSETS_SERVICE.deleteItemsApi}${tableName}`, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status, code } = result;
        return { data, status, code, showToast };
    },
);

// Get Media /assets-service/media/get-all assets-module assets-controller
export const GetAllMedia = createAsyncThunk('commons/getAllMedia', async (params, { dispatch, getState }) => {
    const result = await apiInstance
        .get(ASSETS_SERVICE.getAllMedia)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

//Get User Full Information /user-service/v1/app/full-information/get-by-id/{id} user-module user-controller
export const GetUserFullInformation = createAsyncThunk(
    'commons/getUserFullInformation',
    async (id, { dispatch, getState }) => {
        let result = await apiInstance
            .get(`${USER_SERVICE.getUserFullInformation}${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

//Update User Profile /user-service/v1/app/update user-module user-controller
export const UpdateUserProfile = createAsyncThunk(
    'commons/updateUserProfile',
    async (params, { dispatch }) => {
        const result = await apiInstance
            .put(USER_SERVICE.updateUserProfile, params?.data)
            .then(async function (response) {
                const userId = response?.data?.data?.id;
                const imgData = {
                    user: {
                        id: userId
                    },
                    accessMethod: {
                        id: '5'
                    },
                    description: 'Face recognition'
                };
                // want to update or create image
                if (params?.file != null) {
                    let imageId = params?.updateImage
                        ? (await dispatch(getSelfie(userId)).unwrap())?.data?.data?.id
                        : null;

                    // No previous selfie: create the user image object to get its id
                    if (!imageId) {
                        const {
                            payload: { data: { data: createdImg, success: imgSuccess } = {} } = {},
                        } = await dispatch(createImgObj({ ...imgData, file: params.file }));

                        if (imgSuccess) imageId = createdImg?.id;
                    }

                    if (imageId) {
                        const formData = new FormData();

                        formData.append('id', imageId);
                        formData.append('option', TABLES.USER);
                        formData.append('file', params?.file);
                        await dispatch(UploadImage(formData));
                    }
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

//WebSocket Guard /websocket/guard
export const WebSocketGuard = createAsyncThunk('commons/webSocketGuard', async (params, { dispatch, getState }) => {
    let result = await apiInstance
        .post(`websocket/guard`, params, {
            headers: {
                Accept: '*/*',
            },
        })
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});
//Hard delete
export const GetSoftDeletedRecordsByTable = createAsyncThunk(
    'commons/getSoftDeletedRecordsByTable',
    async (body, { dispatch, getState }) => {
        const result = await apiInstance
            .post(`${ASSETS_SERVICE.getSoftDeletedRecordsByTable}${body.option}`, body?.pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);
export const HardDeleteRecordsByTableAndIds = createAsyncThunk(
    'commons/hardDeleteRecordsByTableAndIds',
    async ({ tableName, body }) => {
        const result = await apiInstance
            .post(`${ASSETS_SERVICE.hardDeleteRecordsByTableAndIds}${tableName}`, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);
// Restore records
export const RestoreRecords = createAsyncThunk('commons/restoreRecords', async (body, { dispatch, getState }) => {
    const result = await apiInstance
        .put(`${ASSETS_SERVICE.restoreRecords}${body.table}`, body?.list)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});
export const GetFilterForEntitiesWithSoftDelete = createAsyncThunk(
    'commons/getFilterForEntitiesWithSoftDelete',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .get(ASSETS_SERVICE.getFilterForEntitiesWithSoftDelete)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// List all the posible device status in the dropdown (done)
export const GetListStatus = createAsyncThunk(
    'commons/getListStatus',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .get(STATUS_SERVICE.getListStatus)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const CustomSearch = createAsyncThunk("commons/CustomSearch",async (params, { dispatch, getState }) => {
    const {body, api} = params;
    const response = await apiInstance.post(`${api}`, body).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const PublicCustomSearch = createAsyncThunk('commons/publicCustomSearch', async (params, { dispatch, getState }) => {
        try {
            const {body, api} = params;
            return await axios.post(`${URL}${api}`, body);
        } catch (error) {
            if (!error.response) {
                errorMsg(error.response.status)
            }
            return { data: error.response.data, status: error.response.status };
        }
    },
);


